import * as React from 'react';
import strings from '../../strings/strings.json';
import OrganisationForm from './components/OrganisationForm';
import { useParams } from 'react-router-dom';
import useGetRequest from 'hooks/useGetRequest';
import { Organisation } from 'models/Organisation';
import { MainSectionWithGaps } from '../../components/sections/MainSection';
import Header from 'components/sections/Header';
import NavBackButton from 'components/buttons/NavBackButton';

export default function UpdateOrganisationPage(): JSX.Element {
    const params = useParams();
    const { id } = params;

    const { data: organisation } = useGetRequest<Organisation>(`organisations/${id}`, !id);

    if (id && !organisation) {
        return <div></div>;
    }

    return (
        <>
            <Header
                title={strings.updateOrganisationPage.title}
                aboveTitleElement={
                    <NavBackButton
                        backButtonTitle={strings.updateOrganisationPage.backButtonTitle}
                        backButtonAria={strings.updateOrganisationPage.backButtonTitleAria}
                        backButtonHref={'/admin/dashboard'}
                    />
                }
            />
            <MainSectionWithGaps>
                <OrganisationForm organisation={organisation} />
            </MainSectionWithGaps>
        </>
    );
}
